import { styled, Grid, Typography, DialogContent, Button, Dialog } from "@mui/material";

export const Container = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  paddingTop: "20px",
  height: "62vh",
  overflow: "auto",
});

export const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    maxWidth: "96vw",
  },
});

export const DocumentViewerContainer = styled(Grid)(({ theme }) => ({
  width: "60%",
  border: `1px solid ${theme.palette.secondary.light}`,
  borderRadius: "5px",
  maxHeight: "66vh",
  overflow: "auto",
  "& #main-viewer": {
    height: "59vh",
    scale: "0.8",
  },
}));

export const DateContainer = styled(Grid)(({ theme }) => ({
  color: theme.palette.secondary.light,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "5px",
  "& .date-number": {
    fontSize: "23px",
    fontWeight: "bold",
  },
  "& .date-details": {
    display: "flex",
    flexDirection: "column",
    "& .MuiTypography-root": {
      lineHeight: "11px",
      fontSize: "10px",
    },
  },
}));

export const SinglePlaceholderContainer = styled(Grid)({
  display: "flex",
  gap: "10px",
  justifyItems: "start",
  alignItems: "center",
  "& .MuiTextField-root": {
    width: "245px",
  },
});

export const Label = styled(Typography)({
  width: "160px",
});

export const AddFromDatabaseOpener = styled(Button)({
  width: "100px",
  fontSize: "12px",
  opacity: "0.3",
  "&:hover": {
    opacity: 1,
  },
});
